/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { SimpleDialog, uploadFile, useUploadStyles } from ".";
import { API_BASE } from "../../AppConfig";
import BSL_ControlContainer from "../BSL_ControlContainer";
import BSL_Button from "../BSL_Button";
import CloseIcon from "@material-ui/icons/Close";
import { CircularProgress, IconButton } from "@material-ui/core";

export const BSL_UploadDocument = (props) => {
    const classes = useUploadStyles();

    const [ts, setTs] = React.useState(Date.now());
    const [image, setImage] = React.useState(
        props.documentFilename ? API_BASE() + "document/" + props.documentFolder + "/" + props.documentFilename : null
    );
    const inputRef = React.useRef(null);
    const [loading, setLoading] = React.useState(false);
    const [fileinputKey, setFileinputKey] = React.useState(0);
    const [openImageView, setOpenImageView] = React.useState(false);

    React.useEffect(() => {
        setImage(
            props.documentFilename ? `${API_BASE()}document/${props.documentFolder}/${props.documentFilename}` : null
        );
    }, [props.documentFilename, props.documentFolder]);

    if (!props.documentFolder) {
        return <div>NO DOCUMENT FOLDER PROVIDED</div>;
    }

    const fileType = image?.endsWith(".pdf") ? "application/pdf" : "";

    return (
        <BSL_ControlContainer
            {...props}
            style={{
                background: "repeating-linear-gradient( 45deg, #efefef, #efefef 10px, #dadada 10px, #dadada 20px)",
                position: "relative",
            }}
        >
            <div className={classes.import_image}>
                <input
                    ref={inputRef}
                    key={"input_" + fileinputKey}
                    accept=".jpg, .png, .gif"
                    className={classes.input}
                    id={"upload-logo" + ts}
                    multiple
                    type="file"
                    onChange={(e) =>
                        uploadFile({ file: e.target.files[0], inputRef, props, setLoading, setFileinputKey, setImage })
                    }
                    disabled={props?.disabled === true}
                />
                <label htmlFor={"upload-logo" + ts}>
                    <BSL_Button
                        secondary
                        variant="contained"
                        component="span"
                        label={props.buttonText}
                        style={{
                            background: "#fffcfcc7",
                        }}
                        disabled={props?.disabled === true}
                    />
                </label>
            </div>
            <IconButton
                className={classes.closeButton}
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => {
                    setLoading(false);
                    setImage(null);
                    if (props.onClear) props.onClear();
                }}
                disabled={props?.disabled === true}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
            <object
                key={image}
                className={classes.image}
                data={image}
                type={fileType}
                onClick={() => {
                    if (image && !image.includes("none")) setOpenImageView(true);
                    else if (inputRef?.current?.click) inputRef.current.click();
                }}
            >
                {!loading ? <div style={{ color: "#888888" }}>{props.backgroundText}</div> : <CircularProgress />}
            </object>
            <SimpleDialog image_url={image} open={openImageView} onClose={() => setOpenImageView(false)} />
        </BSL_ControlContainer>
    );
};

export default BSL_UploadDocument;
